import type { AreaDict } from '../messages'

// Telas de Contas e Cartões (lista + extrato/fatura + form de conta). Prefixo acct.
const accountscards: AreaDict = {
  'pt-BR': {
    // Lista de contas
    'acct.accountsSubtitle': 'Clique numa conta para ver o extrato mês a mês (com saldo no fim de cada mês).',
    'acct.showArchived': 'Mostrar arquivadas',
    'acct.hideArchived': 'Ocultar arquivadas',
    'acct.newAccount': 'Nova conta',
    'acct.colAccount': 'Conta',
    'acct.colBalance': 'Saldo',
    'acct.archivedBadge': 'Arquivada',
    'acct.unarchive': 'Desarquivar',
    'acct.emptyTitle': 'Nenhuma conta ainda',
    'acct.emptyDesc': 'Crie a primeira conta para acompanhar seus saldos e extratos mês a mês.',
    'acct.unarchived': 'Conta desarquivada',
    'acct.unarchiveError': 'Erro ao desarquivar',
    'acct.checkError': 'Erro ao verificar a conta',
    'acct.archiveConfirmTitle': 'Arquivar "{name}"?',
    'acct.archiveConfirmDesc':
      'Esta conta tem {count} lançamento(s) já efetivado(s) e não pode ser excluída (o histórico é preservado). Você pode arquivá-la: ela fica oculta das listas, mas os dados permanecem.',
    'acct.archiveAction': 'Arquivar',
    'acct.archived': 'Conta arquivada',
    'acct.archiveError': 'Erro ao arquivar',
    'acct.deleteConfirmTitle': 'Excluir "{name}"?',
    'acct.deleteConfirmDescPending':
      'Isso remove também {count} lançamento(s) pendente(s) desta conta. Esta ação não pode ser desfeita.',
    'acct.cannotUndo': 'Esta ação não pode ser desfeita.',
    'acct.deleted': 'Conta excluída',
    'acct.deleteError': 'Não foi possível excluir',
    // Tipos de conta (cabeçalhos de grupo)
    'acct.type.corrente': 'Corrente',
    'acct.type.poupanca': 'Poupança',
    'acct.type.carteira': 'Carteira',
    'acct.type.cartao': 'Cartão',
    'acct.type.cash': 'Cash',
    'acct.type.investimento': 'Investimentos',
    // Form de conta
    'acct.typeForm.corrente': 'Conta corrente',
    'acct.nameRequired': 'Informe um nome',
    'acct.invalidValue': 'Valor inválido',
    'acct.updated': 'Conta atualizada',
    'acct.created': 'Conta criada',
    'acct.saveError': 'Erro ao salvar',
    'acct.editAccount': 'Editar conta',
    'acct.formDesc': 'Contas têm moeda própria; o saldo é sempre na moeda dela.',
    'acct.iconLabel': 'Ícone',
    'acct.nameLabel': 'Nome',
    'acct.namePlaceholder': 'Ex.: Conta Corrente',
    'acct.typeLabel': 'Tipo',
    'acct.initialBalance': 'Saldo inicial',
    // Extrato / fatura (compartilhado)
    'acct.transfer': 'Transferência',
    'acct.includeRecurring': 'Incluir recorrente',
    'acct.newTransaction': 'Novo lançamento',
    'acct.currentBalance': 'Saldo atual:',
    'acct.prevBalance': 'Saldo anterior',
    'acct.income': 'Entradas',
    'acct.expenses': 'Saídas',
    'acct.transferOut': 'Transf. saída',
    'acct.transferIn': 'Transf. entrada',
    'acct.backToCurrentMonth': 'Voltar ao mês atual',
    'acct.prevMonth': 'Mês anterior',
    'acct.nextMonth': 'Próximo mês',
    'acct.paidQ': 'Pago?',
    'acct.colDate': 'Data',
    'acct.colDesc': 'Descrição',
    'acct.colCategory': 'Categoria',
    'acct.colValue': 'Valor',
    'acct.markPending': 'Marcar como pendente',
    'acct.markPaid': 'Marcar como pago',
    'acct.pending': 'Pendente',
    'acct.paid': 'Pago',
    'acct.duplicate': 'Duplicar',
    'acct.emptyMonth': 'Nenhum lançamento em {month}',
    'acct.deleteTransferTitle': 'Excluir transferência?',
    'acct.deleteTxTitle': 'Excluir lançamento?',
    'acct.deleteTransferDesc':
      'É uma transferência: as duas pernas (nas duas contas) serão excluídas. Esta ação não pode ser desfeita.',
    'acct.transferDeleted': 'Transferência excluída',
    'acct.txDeleted': 'Lançamento excluído',
    'acct.deleteTxError': 'Erro ao excluir',
    'acct.markedPaid': 'Marcado como pago',
    'acct.markedPending': 'Marcado como pendente',
    'acct.statusError': 'Erro ao atualizar status',
    'acct.accountFallback': 'Conta',
    'acct.cardFallback': 'Cartão',
    'acct.includeRecurringTitle': 'Incluir recorrente — {name}',
    'acct.transferTitle': 'Transferência — {name}',
    // Lista de cartões
    'acct.cardsSubtitle': 'Fatura do mês atual e dívida total por cartão. Clique para lançar e ver mês a mês.',
    'acct.newCard': 'Novo cartão',
    'acct.cardsEmptyTitle': 'Nenhum cartão cadastrado',
    'acct.cardsEmptyDesc': 'Cadastre um cartão para acompanhar a fatura do mês e a dívida total.',
    'acct.colCard': 'Cartão',
    'acct.colDueDate': 'Vencimento',
    'acct.colMonthInvoice': 'Fatura do mês',
    'acct.colTotalDebt': 'Dívida total',
    'acct.colTotalIn': 'Total em {currency}',
    // Fatura do cartão
    'acct.payInvoice': 'Pagar fatura',
    'acct.importInvoice': 'Importar fatura',
    'acct.dueSaved': 'Vencimento salvo',
    'acct.closingSaved': 'Fechamento salvo',
    'acct.dueSaveError': 'Não foi possível salvar o vencimento',
    'acct.closingSaveError': 'Não foi possível salvar o fechamento',
    'acct.closingDayLabel': 'Fechamento — dia',
    'acct.closingDayTitle': 'Compra feita depois deste dia entra na fatura do mês seguinte',
    'acct.dueDayLabel': 'Vencimento — dia',
    'acct.invoiceOf': 'Fatura de',
    'acct.closesOn': 'fecha em {date}',
    'acct.dueOn': 'vence em {date}',
    'acct.invoicePaid': 'Fatura paga',
    'acct.purchases': 'Compras:',
    'acct.debtBalance': 'Saldo devedor:',
    'acct.paidLower': 'pago',
    'acct.filterPlaceholder': 'Buscar descrição, categoria ou tag…',
    'acct.conversionPending': 'Conversão pendente',
    'acct.noFilterMatch': 'Nenhum lançamento corresponde ao filtro.',
    'acct.paymentLabel': 'Pagamento',
    'acct.payInvoiceTitle': 'Pagar fatura — {name}',
    'acct.invoiceSettled': '{n} compra(s) da fatura marcada(s) como paga(s)',
    'acct.paymentRegistered': 'Pagamento registrado',
  },
  en: {
    // Accounts list
    'acct.accountsSubtitle': 'Click an account to see its month-by-month statement (with the balance at the end of each month).',
    'acct.showArchived': 'Show archived',
    'acct.hideArchived': 'Hide archived',
    'acct.newAccount': 'New account',
    'acct.colAccount': 'Account',
    'acct.colBalance': 'Balance',
    'acct.archivedBadge': 'Archived',
    'acct.unarchive': 'Unarchive',
    'acct.emptyTitle': 'No accounts yet',
    'acct.emptyDesc': 'Create your first account to track your balances and month-by-month statements.',
    'acct.unarchived': 'Account unarchived',
    'acct.unarchiveError': 'Error unarchiving',
    'acct.checkError': 'Error checking the account',
    'acct.archiveConfirmTitle': 'Archive "{name}"?',
    'acct.archiveConfirmDesc':
      'This account has {count} settled entry(ies) and cannot be deleted (the history is preserved). You can archive it: it gets hidden from the lists, but the data remains.',
    'acct.archiveAction': 'Archive',
    'acct.archived': 'Account archived',
    'acct.archiveError': 'Error archiving',
    'acct.deleteConfirmTitle': 'Delete "{name}"?',
    'acct.deleteConfirmDescPending':
      'This also removes {count} pending entry(ies) from this account. This action cannot be undone.',
    'acct.cannotUndo': 'This action cannot be undone.',
    'acct.deleted': 'Account deleted',
    'acct.deleteError': 'Could not delete',
    // Account types (group headers)
    'acct.type.corrente': 'Checking',
    'acct.type.poupanca': 'Savings',
    'acct.type.carteira': 'Wallet',
    'acct.type.cartao': 'Card',
    'acct.type.cash': 'Cash',
    'acct.type.investimento': 'Investments',
    // Account form
    'acct.typeForm.corrente': 'Checking account',
    'acct.nameRequired': 'Enter a name',
    'acct.invalidValue': 'Invalid value',
    'acct.updated': 'Account updated',
    'acct.created': 'Account created',
    'acct.saveError': 'Error saving',
    'acct.editAccount': 'Edit account',
    'acct.formDesc': 'Accounts have their own currency; the balance is always in that currency.',
    'acct.iconLabel': 'Icon',
    'acct.nameLabel': 'Name',
    'acct.namePlaceholder': 'E.g.: Checking Account',
    'acct.typeLabel': 'Type',
    'acct.initialBalance': 'Initial balance',
    // Statement / invoice (shared)
    'acct.transfer': 'Transfer',
    'acct.includeRecurring': 'Add recurring',
    'acct.newTransaction': 'New entry',
    'acct.currentBalance': 'Current balance:',
    'acct.prevBalance': 'Previous balance',
    'acct.income': 'Income',
    'acct.expenses': 'Expenses',
    'acct.transferOut': 'Transfer out',
    'acct.transferIn': 'Transfer in',
    'acct.backToCurrentMonth': 'Back to current month',
    'acct.prevMonth': 'Previous month',
    'acct.nextMonth': 'Next month',
    'acct.paidQ': 'Paid?',
    'acct.colDate': 'Date',
    'acct.colDesc': 'Description',
    'acct.colCategory': 'Category',
    'acct.colValue': 'Amount',
    'acct.markPending': 'Mark as pending',
    'acct.markPaid': 'Mark as paid',
    'acct.pending': 'Pending',
    'acct.paid': 'Paid',
    'acct.duplicate': 'Duplicate',
    'acct.emptyMonth': 'No entries in {month}',
    'acct.deleteTransferTitle': 'Delete transfer?',
    'acct.deleteTxTitle': 'Delete entry?',
    'acct.deleteTransferDesc':
      'This is a transfer: both legs (in both accounts) will be deleted. This action cannot be undone.',
    'acct.transferDeleted': 'Transfer deleted',
    'acct.txDeleted': 'Entry deleted',
    'acct.deleteTxError': 'Error deleting',
    'acct.markedPaid': 'Marked as paid',
    'acct.markedPending': 'Marked as pending',
    'acct.statusError': 'Error updating status',
    'acct.accountFallback': 'Account',
    'acct.cardFallback': 'Card',
    'acct.includeRecurringTitle': 'Add recurring — {name}',
    'acct.transferTitle': 'Transfer — {name}',
    // Cards list
    'acct.cardsSubtitle': 'Current month invoice and total debt per card. Click to add entries and view month by month.',
    'acct.newCard': 'New card',
    'acct.cardsEmptyTitle': 'No cards registered',
    'acct.cardsEmptyDesc': 'Register a card to track the current month invoice and the total debt.',
    'acct.colCard': 'Card',
    'acct.colDueDate': 'Due date',
    'acct.colMonthInvoice': 'Month invoice',
    'acct.colTotalDebt': 'Total debt',
    'acct.colTotalIn': 'Total in {currency}',
    // Card invoice
    'acct.payInvoice': 'Pay invoice',
    'acct.importInvoice': 'Import invoice',
    'acct.dueSaved': 'Due day saved',
    'acct.closingSaved': 'Closing day saved',
    'acct.dueSaveError': 'Could not save the due day',
    'acct.closingSaveError': 'Could not save the closing day',
    'acct.closingDayLabel': 'Closing — day',
    'acct.closingDayTitle': 'A purchase made after this day goes onto the next month invoice',
    'acct.dueDayLabel': 'Due — day',
    'acct.invoiceOf': 'Invoice for',
    'acct.closesOn': 'closes on {date}',
    'acct.dueOn': 'due on {date}',
    'acct.invoicePaid': 'Invoice paid',
    'acct.purchases': 'Purchases:',
    'acct.debtBalance': 'Outstanding balance:',
    'acct.paidLower': 'paid',
    'acct.filterPlaceholder': 'Search description, category or tag…',
    'acct.conversionPending': 'Conversion pending',
    'acct.noFilterMatch': 'No entry matches the filter.',
    'acct.paymentLabel': 'Payment',
    'acct.payInvoiceTitle': 'Pay invoice — {name}',
    'acct.invoiceSettled': '{n} invoice purchase(s) marked as paid',
    'acct.paymentRegistered': 'Payment recorded',
  },
  es: {
    // Lista de cuentas
    'acct.accountsSubtitle': 'Haz clic en una cuenta para ver su movimiento mes a mes (con el saldo al final de cada mes).',
    'acct.showArchived': 'Mostrar archivadas',
    'acct.hideArchived': 'Ocultar archivadas',
    'acct.newAccount': 'Nueva cuenta',
    'acct.colAccount': 'Cuenta',
    'acct.colBalance': 'Saldo',
    'acct.archivedBadge': 'Archivada',
    'acct.unarchive': 'Desarchivar',
    'acct.emptyTitle': 'Aún no hay cuentas',
    'acct.emptyDesc': 'Crea la primera cuenta para seguir tus saldos y movimientos mes a mes.',
    'acct.unarchived': 'Cuenta desarchivada',
    'acct.unarchiveError': 'Error al desarchivar',
    'acct.checkError': 'Error al verificar la cuenta',
    'acct.archiveConfirmTitle': '¿Archivar "{name}"?',
    'acct.archiveConfirmDesc':
      'Esta cuenta tiene {count} movimiento(s) ya efectuado(s) y no se puede eliminar (el historial se conserva). Puedes archivarla: queda oculta de las listas, pero los datos permanecen.',
    'acct.archiveAction': 'Archivar',
    'acct.archived': 'Cuenta archivada',
    'acct.archiveError': 'Error al archivar',
    'acct.deleteConfirmTitle': '¿Eliminar "{name}"?',
    'acct.deleteConfirmDescPending':
      'Esto también elimina {count} movimiento(s) pendiente(s) de esta cuenta. Esta acción no se puede deshacer.',
    'acct.cannotUndo': 'Esta acción no se puede deshacer.',
    'acct.deleted': 'Cuenta eliminada',
    'acct.deleteError': 'No se pudo eliminar',
    // Tipos de cuenta (encabezados de grupo)
    'acct.type.corrente': 'Corriente',
    'acct.type.poupanca': 'Ahorro',
    'acct.type.carteira': 'Billetera',
    'acct.type.cartao': 'Tarjeta',
    'acct.type.cash': 'Efectivo',
    'acct.type.investimento': 'Inversiones',
    // Formulario de cuenta
    'acct.typeForm.corrente': 'Cuenta corriente',
    'acct.nameRequired': 'Ingresa un nombre',
    'acct.invalidValue': 'Valor inválido',
    'acct.updated': 'Cuenta actualizada',
    'acct.created': 'Cuenta creada',
    'acct.saveError': 'Error al guardar',
    'acct.editAccount': 'Editar cuenta',
    'acct.formDesc': 'Las cuentas tienen su propia moneda; el saldo siempre está en esa moneda.',
    'acct.iconLabel': 'Ícono',
    'acct.nameLabel': 'Nombre',
    'acct.namePlaceholder': 'Ej.: Cuenta Corriente',
    'acct.typeLabel': 'Tipo',
    'acct.initialBalance': 'Saldo inicial',
    // Movimiento / factura (compartido)
    'acct.transfer': 'Transferencia',
    'acct.includeRecurring': 'Incluir recurrente',
    'acct.newTransaction': 'Nuevo movimiento',
    'acct.currentBalance': 'Saldo actual:',
    'acct.prevBalance': 'Saldo anterior',
    'acct.income': 'Ingresos',
    'acct.expenses': 'Egresos',
    'acct.transferOut': 'Transf. salida',
    'acct.transferIn': 'Transf. entrada',
    'acct.backToCurrentMonth': 'Volver al mes actual',
    'acct.prevMonth': 'Mes anterior',
    'acct.nextMonth': 'Mes siguiente',
    'acct.paidQ': '¿Pagado?',
    'acct.colDate': 'Fecha',
    'acct.colDesc': 'Descripción',
    'acct.colCategory': 'Categoría',
    'acct.colValue': 'Importe',
    'acct.markPending': 'Marcar como pendiente',
    'acct.markPaid': 'Marcar como pagado',
    'acct.pending': 'Pendiente',
    'acct.paid': 'Pagado',
    'acct.duplicate': 'Duplicar',
    'acct.emptyMonth': 'Sin movimientos en {month}',
    'acct.deleteTransferTitle': '¿Eliminar transferencia?',
    'acct.deleteTxTitle': '¿Eliminar movimiento?',
    'acct.deleteTransferDesc':
      'Es una transferencia: se eliminarán las dos partes (en las dos cuentas). Esta acción no se puede deshacer.',
    'acct.transferDeleted': 'Transferencia eliminada',
    'acct.txDeleted': 'Movimiento eliminado',
    'acct.deleteTxError': 'Error al eliminar',
    'acct.markedPaid': 'Marcado como pagado',
    'acct.markedPending': 'Marcado como pendiente',
    'acct.statusError': 'Error al actualizar el estado',
    'acct.accountFallback': 'Cuenta',
    'acct.cardFallback': 'Tarjeta',
    'acct.includeRecurringTitle': 'Incluir recurrente — {name}',
    'acct.transferTitle': 'Transferencia — {name}',
    // Lista de tarjetas
    'acct.cardsSubtitle': 'Factura del mes actual y deuda total por tarjeta. Haz clic para registrar y ver mes a mes.',
    'acct.newCard': 'Nueva tarjeta',
    'acct.cardsEmptyTitle': 'Ninguna tarjeta registrada',
    'acct.cardsEmptyDesc': 'Registra una tarjeta para seguir la factura del mes y la deuda total.',
    'acct.colCard': 'Tarjeta',
    'acct.colDueDate': 'Vencimiento',
    'acct.colMonthInvoice': 'Factura del mes',
    'acct.colTotalDebt': 'Deuda total',
    'acct.colTotalIn': 'Total en {currency}',
    // Factura de la tarjeta
    'acct.payInvoice': 'Pagar factura',
    'acct.importInvoice': 'Importar factura',
    'acct.dueSaved': 'Vencimiento guardado',
    'acct.closingSaved': 'Cierre guardado',
    'acct.dueSaveError': 'No se pudo guardar el vencimiento',
    'acct.closingSaveError': 'No se pudo guardar el cierre',
    'acct.closingDayLabel': 'Cierre — día',
    'acct.closingDayTitle': 'Una compra hecha después de este día entra en la factura del mes siguiente',
    'acct.dueDayLabel': 'Vencimiento — día',
    'acct.invoiceOf': 'Factura de',
    'acct.closesOn': 'cierra el {date}',
    'acct.dueOn': 'vence el {date}',
    'acct.invoicePaid': 'Factura pagada',
    'acct.purchases': 'Compras:',
    'acct.debtBalance': 'Saldo deudor:',
    'acct.paidLower': 'pagado',
    'acct.filterPlaceholder': 'Buscar descripción, categoría o etiqueta…',
    'acct.conversionPending': 'Conversión pendiente',
    'acct.noFilterMatch': 'Ningún movimiento coincide con el filtro.',
    'acct.paymentLabel': 'Pago',
    'acct.payInvoiceTitle': 'Pagar factura — {name}',
    'acct.invoiceSettled': '{n} compra(s) de la factura marcada(s) como pagada(s)',
    'acct.paymentRegistered': 'Pago registrado',
  },
}

export default accountscards
